import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CustomersList from "@/pages/CustomersList";
import CustomerDetail from "@/pages/CustomerDetail";
import KarigarsList from "@/pages/KarigarsList";
import OrdersList from "@/pages/OrdersList";
import OrderCreate from "@/pages/OrderCreate";
import OrderDetail from "@/pages/OrderDetail";
import RemindersList from "@/pages/RemindersList";
import Deliveries from "@/pages/Deliveries";
import Payments from "@/pages/Payments";
import PaymentDetail from "@/pages/PaymentDetail";

// Voucher ERP
import VoucherDashboard from "@/pages/voucher/VoucherDashboard";
import VoucherList from "@/pages/voucher/VoucherList";
import VoucherCreate from "@/pages/voucher/VoucherCreate";
import VoucherView from "@/pages/voucher/VoucherView";
import VoucherItems from "@/pages/voucher/VoucherItems";
import VoucherCustomers from "@/pages/voucher/VoucherCustomers";
import VoucherSalesmen from "@/pages/voucher/VoucherSalesmen";

// Admin
import CompanySettings from "@/pages/settings/CompanySettings";
import AccountSettings from "@/pages/settings/AccountSettings";

import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmailChange from "@/pages/VerifyEmailChange";

const ORDER_ROLES = ["admin", "order_staff", "staff"];
const VOUCHER_ROLES = ["admin", "voucher_staff"];
const ADMIN_ROLES = ["admin"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email-change" element={<VerifyEmailChange />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            {/* Order ERP */}
            <Route path="/" element={<ProtectedRoute roles={ORDER_ROLES}><Dashboard /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute roles={ORDER_ROLES}><OrdersList /></ProtectedRoute>} />
            <Route path="/orders/new" element={<ProtectedRoute roles={ORDER_ROLES}><OrderCreate /></ProtectedRoute>} />
            <Route path="/orders/:id" element={<ProtectedRoute roles={ORDER_ROLES}><OrderDetail /></ProtectedRoute>} />
            <Route path="/deliveries" element={<ProtectedRoute roles={ORDER_ROLES}><Deliveries /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute roles={ORDER_ROLES}><Payments /></ProtectedRoute>} />
            <Route path="/payments/:id" element={<ProtectedRoute roles={ORDER_ROLES}><PaymentDetail /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute roles={ORDER_ROLES}><CustomersList /></ProtectedRoute>} />
            <Route path="/customers/:id" element={<ProtectedRoute roles={ORDER_ROLES}><CustomerDetail /></ProtectedRoute>} />
            <Route path="/karigars" element={<ProtectedRoute roles={ORDER_ROLES}><KarigarsList /></ProtectedRoute>} />
            <Route path="/reminders" element={<ProtectedRoute roles={ORDER_ROLES}><RemindersList /></ProtectedRoute>} />

            {/* Voucher ERP */}
            <Route path="/voucher" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherDashboard /></ProtectedRoute>} />
            <Route path="/voucher/vouchers" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherList /></ProtectedRoute>} />
            <Route path="/voucher/vouchers/new" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherCreate /></ProtectedRoute>} />
            <Route path="/voucher/vouchers/:id" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherView /></ProtectedRoute>} />
            <Route path="/voucher/vouchers/:id/edit" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherCreate /></ProtectedRoute>} />
            <Route path="/voucher/items" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherItems /></ProtectedRoute>} />
            <Route path="/voucher/customers" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherCustomers /></ProtectedRoute>} />
            <Route path="/voucher/salesmen" element={<ProtectedRoute roles={VOUCHER_ROLES}><VoucherSalesmen /></ProtectedRoute>} />

            {/* Admin */}
            <Route path="/settings/company" element={<ProtectedRoute roles={ADMIN_ROLES}><CompanySettings /></ProtectedRoute>} />
            <Route path="/settings/account" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
